import { ReactNode } from 'react'

import { TokenWithLogo } from '@cowprotocol/common-const'
import { Currency, CurrencyAmount } from '@cowprotocol/currency'
import { TokenLogo } from '@cowprotocol/tokens'
import { Modal } from '@cowprotocol/ui'

import { Trans, useLingui } from '@lingui/react/macro'

import * as styledEl from './styled'

import { ApprovalAmountInput } from '../ApprovalAmountInput/ApprovalAmountInput'
import { SwapAmountPreview } from '../SwapAmountPreview/SwapAmountPreview'

export interface ChangeApproveAmountModalPureProps {
  inputToken: TokenWithLogo | null
  // amount that was set by the user or by default (by default, it is equivalent to amountToSwap)
  initialAmount: CurrencyAmount<Currency> | null | undefined
  // amount that needed to be swapped
  amountToSwap: CurrencyAmount<Currency> | null | undefined
  // amount the order is expected to buy; passed through so the preview shows the order being edited
  amountToBuy?: CurrencyAmount<Currency> | null | undefined
  isInvalid?: boolean
  onBack: () => void
  onConfirm: () => void
  onReset: () => void
}

export function ChangeApproveAmountModalPure({
  inputToken,
  initialAmount,
  amountToSwap,
  amountToBuy,
  isInvalid,
  onBack,
  onConfirm,
  onReset,
}: ChangeApproveAmountModalPureProps): ReactNode {
  const { t } = useLingui()

  return (
    <styledEl.Wrapper>
      <Modal.Header onBack={onBack}>
        <styledEl.Title>
          <div>
            <Trans>Edit partial approval</Trans>
          </div>
        </styledEl.Title>
      </Modal.Header>
      <styledEl.SwapInfo>
        <TokenLogo token={inputToken} size={54} />
        <styledEl.SetTitle>
          <Trans>Set approval amount</Trans>
        </styledEl.SetTitle>
        <SwapAmountPreview inputCurrencyAmount={amountToSwap} outputCurrencyAmount={amountToBuy} />
      </styledEl.SwapInfo>
      <ApprovalAmountInput
        onReset={onReset}
        initialApproveAmount={initialAmount}
        tokenWithLogo={inputToken}
        amountToSwap={amountToSwap}
      />
      <styledEl.BtnWrapper>
        <styledEl.ActionButton disabled={isInvalid} onClick={onConfirm}>
          {isInvalid ? t`Amount must be at least trade amount` : t`Confirm`}
        </styledEl.ActionButton>
      </styledEl.BtnWrapper>
    </styledEl.Wrapper>
  )
}
